import React, { useEffect } from 'react';
import { PayPalScriptProvider, PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';

const Buttons = (props) => {
    const [{ isPending, isRejected }] = usePayPalScriptReducer();
    if (isRejected) return <p className="text-xs text-neutral-500" data-testid="checkout-paypal-unavailable">PayPal is unavailable right now — please choose invoice or bank wire.</p>;
    if (isPending) return <p className="text-xs text-neutral-400">PayPal loading…</p>;
    return <PayPalButtons style={{ layout: 'vertical', color: 'gold', shape: 'rect', label: 'paypal' }} {...props} />;
};

// PayPal's SDK rejects a promise when its buttons re-render (e.g. totals change); that's harmless.
const ignoreZoid = (e) => {
    if (String(e.reason?.message || e.reason || '').includes('zoid destroyed')) e.preventDefault();
};

const PayPalCheckout = ({ clientId, ...props }) => {
    useEffect(() => {
        window.addEventListener('unhandledrejection', ignoreZoid);
        return () => window.removeEventListener('unhandledrejection', ignoreZoid);
    }, []);
    return (
        <PayPalScriptProvider options={{ clientId, currency: 'USD', intent: 'capture', disableFunding: 'card' }}>
            <Buttons {...props} />
        </PayPalScriptProvider>
    );
};

export default PayPalCheckout;
